export const APP_ROUTES= {
  "home": {
    "root": {
      "name": "home",
      "path": "/home"
    }
  },
  "patients": {
    "assignments": {
      "root": {
        "name": "patients_assignments",
        "path": "/patients/assignments"
      }
    },
    "view": {
      "info": {
        "view": {
          "root": {
            "name": "patients_patient-detail_patient-info_patient-info-view",
            "path": "/patients/:patientId/info/view"
          }
        },
        "edit": {
          "root": {
            "name": "patients_patient-detail_patient-info_patient-info-edit",
            "path": "/patients/:patientId/info/edit"
          }
        },
        "root": {
          "name": "patients_patient-detail_patient-info",
          "path": "/patients/:patientId/info"
        }
      },
      "subscription": {
        "root": {
          "name": "patients_patient-detail_subscription",
          "path": "/patients/:patientId/subscription"
        }
      },
      "clinicalDocumentation": {
        "clinicalNotes": {
          "root": {
            "name": "patients_patient-detail_clinical-documentation_clinical-notes",
            "path": "/patients/:patientId/clinical-documentation/clinical-notes"
          }
        },
        "view": {
          "root": {
            "name": "patients_patient-detail_clinical-documentation_view",
            "path": "/patients/:patientId/clinical-documentation/:sessionId"
          }
        },
        "register": {
          "root": {
            "name": "patients_patient-detail_clinical-documentation_register",
            "path": "/patients/:patientId/clinical-documentation/register"
          }
        },
        "root": {
          "name": "patients_patient-detail_clinical-documentation",
          "path": "/patients/:patientId/clinical-documentation"
        }
      },
      "appointments": {
        "root": {
          "name": "patients_patient-detail_appointments",
          "path": "/patients/:patientId/appointments"
        }
      },
      "forms": {
        "answers": {
          "root": {
            "name": "patients_patient-detail_forms_answers",
            "path": "/patients/:patientId/forms/:formId/view"
          }
        },
        "root": {
          "name": "patients_patient-detail_forms",
          "path": "/patients/:patientId/forms"
        }
      },
      "legals": {
        "root": {
          "name": "patients_patient-detail_legals",
          "path": "/patients/:patientId/legals"
        }
      },
      "root": {
        "name": "patients_patient-detail",
        "path": "/patients/:patientId"
      }
    },
    "root": {
      "name": "patients",
      "path": "/patients"
    }
  },
  "chat": {
    "connected": {
      "root": {
        "name": "chat_connected",
        "path": "/chat/connect-from-other-location"
      }
    },
    "assignments": {
      "root": {
        "name": "chat_assignments",
        "path": "/chat/assignments"
      }
    },
    "professional": {
      "root": {
        "name": "chat_professional",
        "path": "/chat/professional"
      }
    },
    "customer": {
      "activity": {
        "root": {
          "name": "chat_customer_activityCenter",
          "path": "/chat/:customerId/activity-center"
        }
      },
      "breaks": {
        "registerBreak": {
          "root": {
            "name": "chat_customer_breaks_registerBreak",
            "path": "/chat/:customerId/breaks/create"
          }
        },
        "root": {
          "name": "chat_customer_breaks",
          "path": "/chat/:customerId/breaks"
        }
      },
      "clinicalHistory": {
        "sessions": {
          "view": {
            "root": {
              "name": "chat_customer_clinicalHistory_sessions_view",
              "path": "/chat/:customerId/clinical-history/sessions/view"
            }
          },
          "edit": {
            "root": {
              "name": "chat_customer_clinicalHistory_sessions_edit",
              "path": "/chat/:customerId/clinical-history/sessions/edit"
            }
          },
          "register": {
            "root": {
              "name": "chat_customer_clinicalHistory_sessions_register",
              "path": "/chat/:customerId/clinical-history/sessions/register"
            }
          },
          "root": {
            "name": "chat_customer_clinicalHistory_sessions",
            "path": "/chat/:customerId/clinical-history/sessions"
          }
        },
        "notes": {
          "root": {
            "name": "chat_customer_clinicalHistory_notes",
            "path": "/chat/:customerId/clinical-history/notes"
          }
        },
        "root": {
          "name": "chat_customer_clinicalHistory",
          "path": "/chat/:customerId/clinical-history"
        }
      },
      "legalAgreements": {
        "view": {
          "root": {
            "name": "chat_customer_legalAgreements_view",
            "path": "/chat/:customerId/legal-agreements/:uuid"
          }
        },
        "root": {
          "name": "chat_customer_legalAgreements",
          "path": "/chat/:customerId/legal-agreements"
        }
      },
      "subscription": {
        "plans": {
          "root": {
            "name": "chat_customer_subscription_plan",
            "path": "/chat/:customerId/subscription/plans"
          }
        },
        "sessions": {
          "refound": {
            "root": {
              "name": "chat_customer_subscription_sessions_refound",
              "path": "/chat/:customerId/subscription/sessions/refound"
            }
          },
          "register": {
            "root": {
              "name": "chat_customer_subscription_sessions_register",
              "path": "/chat/:customerId/subscription/sessions/register"
            }
          },
          "root": {
            "name": "chat_customer_subscription_sessions",
            "path": "/chat/:customerId/subscription/sessions"
          }
        },
        "discharge": {
          "root": {
            "name": "chat_customer_subscription_discharge",
            "path": "/chat/:customerId/subscription/discharge"
          }
        },
        "root": {
          "name": "chat_customer_subscription",
          "path": "/chat/:customerId/subscription"
        }
      },
      "events": {
        "root": {
          "name": "chat_customer_events",
          "path": "/chat/:customerId/events"
        }
      },
      "schedule": {
        "register": {
          "couple": {
            "root": {
              "name": "chat_customer_customer_appointments_register_couple",
              "path": "/chat/:customerId/schedule/register/couple"
            }
          },
          "root": {
            "name": "chat_customer_customer_appointments_register",
            "path": "/chat/:customerId/schedule/register"
          }
        },
        "view": {
          "root": {
            "name": "chat_customer_customer_appointments_view",
            "path": "/chat/:customerId/schedule/:appointmentId"
          }
        },
        "edit": {
          "couple": {
            "root": {
              "name": "chat_customer_customer_appointments_edit_couple",
              "path": "/chat/:customerId/schedule/edit/:appointmentId/couple"
            }
          },
          "root": {
            "name": "chat_customer_customer_appointments_edit",
            "path": "/chat/:customerId/schedule/edit/:appointmentId"
          }
        },
        "root": {
          "name": "chat_customer_customer_appointments",
          "path": "/chat/:customerId/schedule"
        }
      },
      "patientDetail": {
        "root": {
          "name": "chat_customer_patientDetail",
          "path": "/chat/:customerId/patient_detail"
        }
      },
      "questionnaires": {
        "answers": {
          "root": {
            "name": "chat_customer_for_anwswers",
            "path": "/chat/:customerId/questionnaires/:quizId"
          }
        },
        "send": {
          "root": {
            "name": "chat_customer_for_send",
            "path": "/chat/:customerId/questionnaires/create"
          }
        },
        "root": {
          "name": "chat_customer_for",
          "path": "/chat/:customerId/questionnaires"
        }
      },
      "root": {
        "name": "chat_customer",
        "path": "/chat/:customerId"
      }
    },
    "root": {
      "name": "chat",
      "path": "/chat"
    }
  },
  "calendars": {
    "config": {
      "schedule": {
        "root": {
          "name": "calendars_config_schedule",
          "path": "/calendars/configuration/schedule"
        }
      },
      "advice_policy": {
        "root": {
          "name": "calendars_config_advicePolicy",
          "path": "/calendars/configuration/advice-policy"
        }
      },
      "root": {
        "name": "calendars_config",
        "path": "/calendars/configuration"
      }
    },
    "sync": {
      "root": {
        "name": "calendars_sync",
        "path": "/calendars/sync"
      }
    },
    "view": {
      "root": {
        "name": "calendars_view",
        "path": "/calendars/view"
      }
    },
    "root": {
      "name": "calendars",
      "path": "/calendars"
    }
  },
  "activity": {
    "root": {
      "name": "activityCenter",
      "path": "/activity-center"
    }
  },
  "settings": {
    "subscriptions": {
      "payment": {
        "add": {
          "root": {
            "name": "settings_subscriptions_payment_add",
            "path": "/settings/subscriptions/payment/add"
          }
        },
        "root": {
          "name": "settings_subscriptions_payment",
          "path": "/settings/subscriptions/payment"
        }
      },
      "plan": {
        "root": {
          "name": "settings_subscriptions_plan",
          "path": "/settings/subscriptions/plan"
        }
      },
      "privatePlan": {
        "root": {
          "name": "settings_subscriptions_privatePlan",
          "path": "/settings/subscriptions/:planId/private-patient-plan"
        }
      },
      "promoCode": {
        "root": {
          "name": "settings_subscriptions_promoCode",
          "path": "/settings/subscriptions/promo-code"
        }
      },
      "cancel": {
        "reason": {
          "root": {
            "name": "settings_subscriptions_cancel_reason",
            "path": "/settings/subscriptions/cancel/reason"
          }
        },
        "root": {
          "name": "settings_subscriptions_cancel",
          "path": "/settings/subscriptions/cancel"
        }
      },
      "sessions": {
        "root": {
          "name": "settings_subscriptions_sessions",
          "path": "/settings/subscriptions/sessions"
        }
      },
      "extra_sessions": {
        "root": {
          "name": "settings_subscriptions_extra_sessions",
          "path": "/settings/subscriptions/extra-sessions"
        }
      },
      "root": {
        "name": "settings_subscriptions",
        "path": "/settings/subscriptions"
      }
    },
    "loyaltyPlan": {
      "root": {
        "name": "settings_loyaltyPlan",
        "path": "/settings/objectives"
      }
    },
    "account": {
      "username": {
        "root": {
          "name": "settings_account_username",
          "path": "/settings/account/username"
        }
      },
      "password": {
        "root": {
          "name": "settings_account_password",
          "path": "/settings/account/password"
        }
      },
      "email": {
        "root": {
          "name": "settings_account_email",
          "path": "/settings/account/email"
        }
      },
      "description": {
        "root": {
          "name": "settings_account_description",
          "path": "/settings/account/description"
        }
      },
      "iban": {
        "root": {
          "name": "settings_account_iban",
          "path": "/settings/account/iban"
        }
      },
      "delete": {
        "reason": {
          "root": {
            "name": "settings_account_delete_reason",
            "path": "/settings/account/delete/reason"
          }
        },
        "root": {
          "name": "settings_account_delete",
          "path": "/settings/account/delete"
        }
      },
      "root": {
        "name": "settings_account",
        "path": "/settings/account"
      }
    },
    "configuration": {
      "schedule": {
        "root": {
          "name": "settings_myPreferences_schedule",
          "path": "/settings/configuration/schedule"
        }
      },
      "areas": {
        "root": {
          "name": "settings_myPreferences_areas",
          "path": "/settings/configuration/areas"
        }
      },
      "capaticy": {
        "root": {
          "name": "settings_myPreferences_patients",
          "path": "/settings/configuration/number-patients"
        }
      },
      "trial": {
        "root": {
          "name": "settings_myPreferences_trial",
          "path": "/settings/configuration/trial-period"
        }
      },
      "therapeuticApproaches": {
        "root": {
          "name": "settings_myPreferences_therapeutic-approaches",
          "path": "/settings/configuration/therapeutic-approaches"
        }
      },
      "educations": {
        "root": {
          "name": "settings_myPreferences_educations",
          "path": "/settings/configuration/educations"
        }
      },
      "additionalLanguages": {
        "root": {
          "name": "settings_myPreferences_additional-languages",
          "path": "/settings/configuration/additional-languages"
        }
      },
      "pricePerSession": {
        "root": {
          "name": "settings_myPreferences_price-per-session",
          "path": "/settings/configuration/price-per-session"
        }
      },
      "timeZone": {
        "root": {
          "name": "settings_myPreferences_timeZone",
          "path": "/settings/configuration/time_zone"
        }
      },
      "root": {
        "name": "settings_myPreferences",
        "path": "/settings/configuration"
      }
    },
    "help": {
      "view": {
        "root": {
          "name": "settings_help_helpView",
          "path": "/settings/help/:tag"
        }
      },
      "root": {
        "name": "settings_help",
        "path": "/settings/help"
      }
    },
    "invoices": {
      "detail": {
        "root": {
          "name": "settings_invoices_invoices_detail",
          "path": "/settings/invoices/invoices/detail/:year/:month"
        }
      },
      "root": {
        "name": "settings_invoices",
        "path": "/settings/invoices"
      }
    },
    "payments": {
      "detail": {
        "root": {
          "name": "settings_payments_payments_detail",
          "path": "/settings/payments/payments/detail/:year/:month"
        }
      },
      "root": {
        "name": "settings_payments",
        "path": "/settings/payments"
      }
    },
    "agreements": {
      "view": {
        "root": {
          "name": "settings_legalAgreements_view",
          "path": "/settings/legal-agreements/:uuid"
        }
      },
      "root": {
        "name": "settings_legalAgreements",
        "path": "/settings/legal-agreements"
      }
    },
    "notifications": {
      "root": {
        "name": "settings_notifications",
        "path": "/settings/notifications"
      }
    },
    "questionnaires": {
      "root": {
        "name": "settings_questionnaires",
        "path": "/settings/questionnaires"
      }
    },
    "patientReferral": {
      "root": {
        "name": "settings_referral",
        "path": "/settings/referral"
      }
    },
    "privacy": {
      "root": {
        "name": "settings_privacy",
        "path": "/settings/privacy"
      }
    },
    "timeZone": {
      "root": {
        "name": "settings_timeZone",
        "path": "/settings/time_zone"
      }
    },
    "root": {
      "name": "settings",
      "path": "/settings"
    }
  },
  "error": {
    "404": {
      "root": {
        "name": "error_404",
        "path": "/errors/404"
      }
    },
    "offline": {
      "root": {
        "name": "error_offline",
        "path": "/errors/offline"
      }
    },
    "root": {
      "name": "error",
      "path": "/errors"
    }
  },
  "login": {
    "root": {
      "name": "login",
      "path": "/login"
    }
  },
  "recoverPassword": {
    "root": {
      "name": "recoverPassword",
      "path": "/recover-password"
    }
  },
  "resetPassword": {
    "root": {
      "name": "resetPassword",
      "path": "/reset-password"
    }
  },
  "onboarding": {
    "root": {
      "name": "guest",
      "path": "/guest"
    }
  },
  "code": {
    "root": {
      "name": "loginCode",
      "path": "/login-code"
    }
  },
  "refreshStripe": {
    "root": {
      "name": "refreshStripe",
      "path": "/refresh-stripe-account"
    }
  },
  "sso": {
    "root": {
      "name": "sso",
      "path": "/auth"
    }
  },
  "agent": {
    "root": {
      "name": "agent",
      "path": "/agent"
    }
  },
  "root": {
    "name": "root",
    "path": "/"
  }
} as const

export const APP_HOME_ROUTES= {
  "root": {
    "name": "home",
    "path": "/home"
  }
} as const

export const APP_PATIENTS_ROUTES= {
  "assignments": {
    "root": {
      "name": "patients_assignments",
      "path": "/patients/assignments"
    }
  },
  "view": {
    "info": {
      "view": {
        "root": {
          "name": "patients_patient-detail_patient-info_patient-info-view",
          "path": "/patients/:patientId/info/view"
        }
      },
      "edit": {
        "root": {
          "name": "patients_patient-detail_patient-info_patient-info-edit",
          "path": "/patients/:patientId/info/edit"
        }
      },
      "root": {
        "name": "patients_patient-detail_patient-info",
        "path": "/patients/:patientId/info"
      }
    },
    "subscription": {
      "root": {
        "name": "patients_patient-detail_subscription",
        "path": "/patients/:patientId/subscription"
      }
    },
    "clinicalDocumentation": {
      "clinicalNotes": {
        "root": {
          "name": "patients_patient-detail_clinical-documentation_clinical-notes",
          "path": "/patients/:patientId/clinical-documentation/clinical-notes"
        }
      },
      "view": {
        "root": {
          "name": "patients_patient-detail_clinical-documentation_view",
          "path": "/patients/:patientId/clinical-documentation/:sessionId"
        }
      },
      "register": {
        "root": {
          "name": "patients_patient-detail_clinical-documentation_register",
          "path": "/patients/:patientId/clinical-documentation/register"
        }
      },
      "root": {
        "name": "patients_patient-detail_clinical-documentation",
        "path": "/patients/:patientId/clinical-documentation"
      }
    },
    "appointments": {
      "root": {
        "name": "patients_patient-detail_appointments",
        "path": "/patients/:patientId/appointments"
      }
    },
    "forms": {
      "answers": {
        "root": {
          "name": "patients_patient-detail_forms_answers",
          "path": "/patients/:patientId/forms/:formId/view"
        }
      },
      "root": {
        "name": "patients_patient-detail_forms",
        "path": "/patients/:patientId/forms"
      }
    },
    "legals": {
      "root": {
        "name": "patients_patient-detail_legals",
        "path": "/patients/:patientId/legals"
      }
    },
    "root": {
      "name": "patients_patient-detail",
      "path": "/patients/:patientId"
    }
  },
  "root": {
    "name": "patients",
    "path": "/patients"
  }
} as const

export const APP_PATIENTS_ASSIGNMENTS_ROUTES= {
  "root": {
    "name": "patients_assignments",
    "path": "/patients/assignments"
  }
} as const

export const APP_PATIENTS_VIEW_ROUTES= {
  "info": {
    "view": {
      "root": {
        "name": "patients_patient-detail_patient-info_patient-info-view",
        "path": "/patients/:patientId/info/view"
      }
    },
    "edit": {
      "root": {
        "name": "patients_patient-detail_patient-info_patient-info-edit",
        "path": "/patients/:patientId/info/edit"
      }
    },
    "root": {
      "name": "patients_patient-detail_patient-info",
      "path": "/patients/:patientId/info"
    }
  },
  "subscription": {
    "root": {
      "name": "patients_patient-detail_subscription",
      "path": "/patients/:patientId/subscription"
    }
  },
  "clinicalDocumentation": {
    "clinicalNotes": {
      "root": {
        "name": "patients_patient-detail_clinical-documentation_clinical-notes",
        "path": "/patients/:patientId/clinical-documentation/clinical-notes"
      }
    },
    "view": {
      "root": {
        "name": "patients_patient-detail_clinical-documentation_view",
        "path": "/patients/:patientId/clinical-documentation/:sessionId"
      }
    },
    "register": {
      "root": {
        "name": "patients_patient-detail_clinical-documentation_register",
        "path": "/patients/:patientId/clinical-documentation/register"
      }
    },
    "root": {
      "name": "patients_patient-detail_clinical-documentation",
      "path": "/patients/:patientId/clinical-documentation"
    }
  },
  "appointments": {
    "root": {
      "name": "patients_patient-detail_appointments",
      "path": "/patients/:patientId/appointments"
    }
  },
  "forms": {
    "answers": {
      "root": {
        "name": "patients_patient-detail_forms_answers",
        "path": "/patients/:patientId/forms/:formId/view"
      }
    },
    "root": {
      "name": "patients_patient-detail_forms",
      "path": "/patients/:patientId/forms"
    }
  },
  "legals": {
    "root": {
      "name": "patients_patient-detail_legals",
      "path": "/patients/:patientId/legals"
    }
  },
  "root": {
    "name": "patients_patient-detail",
    "path": "/patients/:patientId"
  }
} as const

export const APP_PATIENTS_VIEW_INFO_ROUTES= {
  "view": {
    "root": {
      "name": "patients_patient-detail_patient-info_patient-info-view",
      "path": "/patients/:patientId/info/view"
    }
  },
  "edit": {
    "root": {
      "name": "patients_patient-detail_patient-info_patient-info-edit",
      "path": "/patients/:patientId/info/edit"
    }
  },
  "root": {
    "name": "patients_patient-detail_patient-info",
    "path": "/patients/:patientId/info"
  }
} as const

export const APP_PATIENTS_VIEW_INFO_VIEW_ROUTES= {
  "root": {
    "name": "patients_patient-detail_patient-info_patient-info-view",
    "path": "/patients/:patientId/info/view"
  }
} as const

export const APP_PATIENTS_VIEW_INFO_EDIT_ROUTES= {
  "root": {
    "name": "patients_patient-detail_patient-info_patient-info-edit",
    "path": "/patients/:patientId/info/edit"
  }
} as const

export const APP_PATIENTS_VIEW_SUBSCRIPTION_ROUTES= {
  "root": {
    "name": "patients_patient-detail_subscription",
    "path": "/patients/:patientId/subscription"
  }
} as const

export const APP_PATIENTS_VIEW_CLINICALDOCUMENTATION_ROUTES= {
  "clinicalNotes": {
    "root": {
      "name": "patients_patient-detail_clinical-documentation_clinical-notes",
      "path": "/patients/:patientId/clinical-documentation/clinical-notes"
    }
  },
  "view": {
    "root": {
      "name": "patients_patient-detail_clinical-documentation_view",
      "path": "/patients/:patientId/clinical-documentation/:sessionId"
    }
  },
  "register": {
    "root": {
      "name": "patients_patient-detail_clinical-documentation_register",
      "path": "/patients/:patientId/clinical-documentation/register"
    }
  },
  "root": {
    "name": "patients_patient-detail_clinical-documentation",
    "path": "/patients/:patientId/clinical-documentation"
  }
} as const

export const APP_PATIENTS_VIEW_CLINICALDOCUMENTATION_CLINICALNOTES_ROUTES= {
  "root": {
    "name": "patients_patient-detail_clinical-documentation_clinical-notes",
    "path": "/patients/:patientId/clinical-documentation/clinical-notes"
  }
} as const

export const APP_PATIENTS_VIEW_CLINICALDOCUMENTATION_VIEW_ROUTES= {
  "root": {
    "name": "patients_patient-detail_clinical-documentation_view",
    "path": "/patients/:patientId/clinical-documentation/:sessionId"
  }
} as const

export const APP_PATIENTS_VIEW_CLINICALDOCUMENTATION_REGISTER_ROUTES= {
  "root": {
    "name": "patients_patient-detail_clinical-documentation_register",
    "path": "/patients/:patientId/clinical-documentation/register"
  }
} as const

export const APP_PATIENTS_VIEW_APPOINTMENTS_ROUTES= {
  "root": {
    "name": "patients_patient-detail_appointments",
    "path": "/patients/:patientId/appointments"
  }
} as const

export const APP_PATIENTS_VIEW_FORMS_ROUTES= {
  "answers": {
    "root": {
      "name": "patients_patient-detail_forms_answers",
      "path": "/patients/:patientId/forms/:formId/view"
    }
  },
  "root": {
    "name": "patients_patient-detail_forms",
    "path": "/patients/:patientId/forms"
  }
} as const

export const APP_PATIENTS_VIEW_FORMS_ANSWERS_ROUTES= {
  "root": {
    "name": "patients_patient-detail_forms_answers",
    "path": "/patients/:patientId/forms/:formId/view"
  }
} as const

export const APP_PATIENTS_VIEW_LEGALS_ROUTES= {
  "root": {
    "name": "patients_patient-detail_legals",
    "path": "/patients/:patientId/legals"
  }
} as const

export const APP_CHAT_ROUTES= {
  "connected": {
    "root": {
      "name": "chat_connected",
      "path": "/chat/connect-from-other-location"
    }
  },
  "assignments": {
    "root": {
      "name": "chat_assignments",
      "path": "/chat/assignments"
    }
  },
  "professional": {
    "root": {
      "name": "chat_professional",
      "path": "/chat/professional"
    }
  },
  "customer": {
    "activity": {
      "root": {
        "name": "chat_customer_activityCenter",
        "path": "/chat/:customerId/activity-center"
      }
    },
    "breaks": {
      "registerBreak": {
        "root": {
          "name": "chat_customer_breaks_registerBreak",
          "path": "/chat/:customerId/breaks/create"
        }
      },
      "root": {
        "name": "chat_customer_breaks",
        "path": "/chat/:customerId/breaks"
      }
    },
    "clinicalHistory": {
      "sessions": {
        "view": {
          "root": {
            "name": "chat_customer_clinicalHistory_sessions_view",
            "path": "/chat/:customerId/clinical-history/sessions/view"
          }
        },
        "edit": {
          "root": {
            "name": "chat_customer_clinicalHistory_sessions_edit",
            "path": "/chat/:customerId/clinical-history/sessions/edit"
          }
        },
        "register": {
          "root": {
            "name": "chat_customer_clinicalHistory_sessions_register",
            "path": "/chat/:customerId/clinical-history/sessions/register"
          }
        },
        "root": {
          "name": "chat_customer_clinicalHistory_sessions",
          "path": "/chat/:customerId/clinical-history/sessions"
        }
      },
      "notes": {
        "root": {
          "name": "chat_customer_clinicalHistory_notes",
          "path": "/chat/:customerId/clinical-history/notes"
        }
      },
      "root": {
        "name": "chat_customer_clinicalHistory",
        "path": "/chat/:customerId/clinical-history"
      }
    },
    "legalAgreements": {
      "view": {
        "root": {
          "name": "chat_customer_legalAgreements_view",
          "path": "/chat/:customerId/legal-agreements/:uuid"
        }
      },
      "root": {
        "name": "chat_customer_legalAgreements",
        "path": "/chat/:customerId/legal-agreements"
      }
    },
    "subscription": {
      "plans": {
        "root": {
          "name": "chat_customer_subscription_plan",
          "path": "/chat/:customerId/subscription/plans"
        }
      },
      "sessions": {
        "refound": {
          "root": {
            "name": "chat_customer_subscription_sessions_refound",
            "path": "/chat/:customerId/subscription/sessions/refound"
          }
        },
        "register": {
          "root": {
            "name": "chat_customer_subscription_sessions_register",
            "path": "/chat/:customerId/subscription/sessions/register"
          }
        },
        "root": {
          "name": "chat_customer_subscription_sessions",
          "path": "/chat/:customerId/subscription/sessions"
        }
      },
      "discharge": {
        "root": {
          "name": "chat_customer_subscription_discharge",
          "path": "/chat/:customerId/subscription/discharge"
        }
      },
      "root": {
        "name": "chat_customer_subscription",
        "path": "/chat/:customerId/subscription"
      }
    },
    "events": {
      "root": {
        "name": "chat_customer_events",
        "path": "/chat/:customerId/events"
      }
    },
    "schedule": {
      "register": {
        "couple": {
          "root": {
            "name": "chat_customer_customer_appointments_register_couple",
            "path": "/chat/:customerId/schedule/register/couple"
          }
        },
        "root": {
          "name": "chat_customer_customer_appointments_register",
          "path": "/chat/:customerId/schedule/register"
        }
      },
      "view": {
        "root": {
          "name": "chat_customer_customer_appointments_view",
          "path": "/chat/:customerId/schedule/:appointmentId"
        }
      },
      "edit": {
        "couple": {
          "root": {
            "name": "chat_customer_customer_appointments_edit_couple",
            "path": "/chat/:customerId/schedule/edit/:appointmentId/couple"
          }
        },
        "root": {
          "name": "chat_customer_customer_appointments_edit",
          "path": "/chat/:customerId/schedule/edit/:appointmentId"
        }
      },
      "root": {
        "name": "chat_customer_customer_appointments",
        "path": "/chat/:customerId/schedule"
      }
    },
    "patientDetail": {
      "root": {
        "name": "chat_customer_patientDetail",
        "path": "/chat/:customerId/patient_detail"
      }
    },
    "questionnaires": {
      "answers": {
        "root": {
          "name": "chat_customer_for_anwswers",
          "path": "/chat/:customerId/questionnaires/:quizId"
        }
      },
      "send": {
        "root": {
          "name": "chat_customer_for_send",
          "path": "/chat/:customerId/questionnaires/create"
        }
      },
      "root": {
        "name": "chat_customer_for",
        "path": "/chat/:customerId/questionnaires"
      }
    },
    "root": {
      "name": "chat_customer",
      "path": "/chat/:customerId"
    }
  },
  "root": {
    "name": "chat",
    "path": "/chat"
  }
} as const

export const APP_CHAT_CONNECTED_ROUTES= {
  "root": {
    "name": "chat_connected",
    "path": "/chat/connect-from-other-location"
  }
} as const

export const APP_CHAT_ASSIGNMENTS_ROUTES= {
  "root": {
    "name": "chat_assignments",
    "path": "/chat/assignments"
  }
} as const

export const APP_CHAT_PROFESSIONAL_ROUTES= {
  "root": {
    "name": "chat_professional",
    "path": "/chat/professional"
  }
} as const

export const APP_CHAT_CUSTOMER_ROUTES= {
  "activity": {
    "root": {
      "name": "chat_customer_activityCenter",
      "path": "/chat/:customerId/activity-center"
    }
  },
  "breaks": {
    "registerBreak": {
      "root": {
        "name": "chat_customer_breaks_registerBreak",
        "path": "/chat/:customerId/breaks/create"
      }
    },
    "root": {
      "name": "chat_customer_breaks",
      "path": "/chat/:customerId/breaks"
    }
  },
  "clinicalHistory": {
    "sessions": {
      "view": {
        "root": {
          "name": "chat_customer_clinicalHistory_sessions_view",
          "path": "/chat/:customerId/clinical-history/sessions/view"
        }
      },
      "edit": {
        "root": {
          "name": "chat_customer_clinicalHistory_sessions_edit",
          "path": "/chat/:customerId/clinical-history/sessions/edit"
        }
      },
      "register": {
        "root": {
          "name": "chat_customer_clinicalHistory_sessions_register",
          "path": "/chat/:customerId/clinical-history/sessions/register"
        }
      },
      "root": {
        "name": "chat_customer_clinicalHistory_sessions",
        "path": "/chat/:customerId/clinical-history/sessions"
      }
    },
    "notes": {
      "root": {
        "name": "chat_customer_clinicalHistory_notes",
        "path": "/chat/:customerId/clinical-history/notes"
      }
    },
    "root": {
      "name": "chat_customer_clinicalHistory",
      "path": "/chat/:customerId/clinical-history"
    }
  },
  "legalAgreements": {
    "view": {
      "root": {
        "name": "chat_customer_legalAgreements_view",
        "path": "/chat/:customerId/legal-agreements/:uuid"
      }
    },
    "root": {
      "name": "chat_customer_legalAgreements",
      "path": "/chat/:customerId/legal-agreements"
    }
  },
  "subscription": {
    "plans": {
      "root": {
        "name": "chat_customer_subscription_plan",
        "path": "/chat/:customerId/subscription/plans"
      }
    },
    "sessions": {
      "refound": {
        "root": {
          "name": "chat_customer_subscription_sessions_refound",
          "path": "/chat/:customerId/subscription/sessions/refound"
        }
      },
      "register": {
        "root": {
          "name": "chat_customer_subscription_sessions_register",
          "path": "/chat/:customerId/subscription/sessions/register"
        }
      },
      "root": {
        "name": "chat_customer_subscription_sessions",
        "path": "/chat/:customerId/subscription/sessions"
      }
    },
    "discharge": {
      "root": {
        "name": "chat_customer_subscription_discharge",
        "path": "/chat/:customerId/subscription/discharge"
      }
    },
    "root": {
      "name": "chat_customer_subscription",
      "path": "/chat/:customerId/subscription"
    }
  },
  "events": {
    "root": {
      "name": "chat_customer_events",
      "path": "/chat/:customerId/events"
    }
  },
  "schedule": {
    "register": {
      "couple": {
        "root": {
          "name": "chat_customer_customer_appointments_register_couple",
          "path": "/chat/:customerId/schedule/register/couple"
        }
      },
      "root": {
        "name": "chat_customer_customer_appointments_register",
        "path": "/chat/:customerId/schedule/register"
      }
    },
    "view": {
      "root": {
        "name": "chat_customer_customer_appointments_view",
        "path": "/chat/:customerId/schedule/:appointmentId"
      }
    },
    "edit": {
      "couple": {
        "root": {
          "name": "chat_customer_customer_appointments_edit_couple",
          "path": "/chat/:customerId/schedule/edit/:appointmentId/couple"
        }
      },
      "root": {
        "name": "chat_customer_customer_appointments_edit",
        "path": "/chat/:customerId/schedule/edit/:appointmentId"
      }
    },
    "root": {
      "name": "chat_customer_customer_appointments",
      "path": "/chat/:customerId/schedule"
    }
  },
  "patientDetail": {
    "root": {
      "name": "chat_customer_patientDetail",
      "path": "/chat/:customerId/patient_detail"
    }
  },
  "questionnaires": {
    "answers": {
      "root": {
        "name": "chat_customer_for_anwswers",
        "path": "/chat/:customerId/questionnaires/:quizId"
      }
    },
    "send": {
      "root": {
        "name": "chat_customer_for_send",
        "path": "/chat/:customerId/questionnaires/create"
      }
    },
    "root": {
      "name": "chat_customer_for",
      "path": "/chat/:customerId/questionnaires"
    }
  },
  "root": {
    "name": "chat_customer",
    "path": "/chat/:customerId"
  }
} as const

export const APP_CHAT_CUSTOMER_ACTIVITY_ROUTES= {
  "root": {
    "name": "chat_customer_activityCenter",
    "path": "/chat/:customerId/activity-center"
  }
} as const

export const APP_CHAT_CUSTOMER_BREAKS_ROUTES= {
  "registerBreak": {
    "root": {
      "name": "chat_customer_breaks_registerBreak",
      "path": "/chat/:customerId/breaks/create"
    }
  },
  "root": {
    "name": "chat_customer_breaks",
    "path": "/chat/:customerId/breaks"
  }
} as const

export const APP_CHAT_CUSTOMER_BREAKS_REGISTERBREAK_ROUTES= {
  "root": {
    "name": "chat_customer_breaks_registerBreak",
    "path": "/chat/:customerId/breaks/create"
  }
} as const

export const APP_CHAT_CUSTOMER_CLINICALHISTORY_ROUTES= {
  "sessions": {
    "view": {
      "root": {
        "name": "chat_customer_clinicalHistory_sessions_view",
        "path": "/chat/:customerId/clinical-history/sessions/view"
      }
    },
    "edit": {
      "root": {
        "name": "chat_customer_clinicalHistory_sessions_edit",
        "path": "/chat/:customerId/clinical-history/sessions/edit"
      }
    },
    "register": {
      "root": {
        "name": "chat_customer_clinicalHistory_sessions_register",
        "path": "/chat/:customerId/clinical-history/sessions/register"
      }
    },
    "root": {
      "name": "chat_customer_clinicalHistory_sessions",
      "path": "/chat/:customerId/clinical-history/sessions"
    }
  },
  "notes": {
    "root": {
      "name": "chat_customer_clinicalHistory_notes",
      "path": "/chat/:customerId/clinical-history/notes"
    }
  },
  "root": {
    "name": "chat_customer_clinicalHistory",
    "path": "/chat/:customerId/clinical-history"
  }
} as const

export const APP_CHAT_CUSTOMER_CLINICALHISTORY_SESSIONS_ROUTES= {
  "view": {
    "root": {
      "name": "chat_customer_clinicalHistory_sessions_view",
      "path": "/chat/:customerId/clinical-history/sessions/view"
    }
  },
  "edit": {
    "root": {
      "name": "chat_customer_clinicalHistory_sessions_edit",
      "path": "/chat/:customerId/clinical-history/sessions/edit"
    }
  },
  "register": {
    "root": {
      "name": "chat_customer_clinicalHistory_sessions_register",
      "path": "/chat/:customerId/clinical-history/sessions/register"
    }
  },
  "root": {
    "name": "chat_customer_clinicalHistory_sessions",
    "path": "/chat/:customerId/clinical-history/sessions"
  }
} as const

export const APP_CHAT_CUSTOMER_CLINICALHISTORY_SESSIONS_VIEW_ROUTES= {
  "root": {
    "name": "chat_customer_clinicalHistory_sessions_view",
    "path": "/chat/:customerId/clinical-history/sessions/view"
  }
} as const

export const APP_CHAT_CUSTOMER_CLINICALHISTORY_SESSIONS_EDIT_ROUTES= {
  "root": {
    "name": "chat_customer_clinicalHistory_sessions_edit",
    "path": "/chat/:customerId/clinical-history/sessions/edit"
  }
} as const

export const APP_CHAT_CUSTOMER_CLINICALHISTORY_SESSIONS_REGISTER_ROUTES= {
  "root": {
    "name": "chat_customer_clinicalHistory_sessions_register",
    "path": "/chat/:customerId/clinical-history/sessions/register"
  }
} as const

export const APP_CHAT_CUSTOMER_CLINICALHISTORY_NOTES_ROUTES= {
  "root": {
    "name": "chat_customer_clinicalHistory_notes",
    "path": "/chat/:customerId/clinical-history/notes"
  }
} as const

export const APP_CHAT_CUSTOMER_LEGALAGREEMENTS_ROUTES= {
  "view": {
    "root": {
      "name": "chat_customer_legalAgreements_view",
      "path": "/chat/:customerId/legal-agreements/:uuid"
    }
  },
  "root": {
    "name": "chat_customer_legalAgreements",
    "path": "/chat/:customerId/legal-agreements"
  }
} as const

export const APP_CHAT_CUSTOMER_LEGALAGREEMENTS_VIEW_ROUTES= {
  "root": {
    "name": "chat_customer_legalAgreements_view",
    "path": "/chat/:customerId/legal-agreements/:uuid"
  }
} as const

export const APP_CHAT_CUSTOMER_SUBSCRIPTION_ROUTES= {
  "plans": {
    "root": {
      "name": "chat_customer_subscription_plan",
      "path": "/chat/:customerId/subscription/plans"
    }
  },
  "sessions": {
    "refound": {
      "root": {
        "name": "chat_customer_subscription_sessions_refound",
        "path": "/chat/:customerId/subscription/sessions/refound"
      }
    },
    "register": {
      "root": {
        "name": "chat_customer_subscription_sessions_register",
        "path": "/chat/:customerId/subscription/sessions/register"
      }
    },
    "root": {
      "name": "chat_customer_subscription_sessions",
      "path": "/chat/:customerId/subscription/sessions"
    }
  },
  "discharge": {
    "root": {
      "name": "chat_customer_subscription_discharge",
      "path": "/chat/:customerId/subscription/discharge"
    }
  },
  "root": {
    "name": "chat_customer_subscription",
    "path": "/chat/:customerId/subscription"
  }
} as const

export const APP_CHAT_CUSTOMER_SUBSCRIPTION_PLANS_ROUTES= {
  "root": {
    "name": "chat_customer_subscription_plan",
    "path": "/chat/:customerId/subscription/plans"
  }
} as const

export const APP_CHAT_CUSTOMER_SUBSCRIPTION_SESSIONS_ROUTES= {
  "refound": {
    "root": {
      "name": "chat_customer_subscription_sessions_refound",
      "path": "/chat/:customerId/subscription/sessions/refound"
    }
  },
  "register": {
    "root": {
      "name": "chat_customer_subscription_sessions_register",
      "path": "/chat/:customerId/subscription/sessions/register"
    }
  },
  "root": {
    "name": "chat_customer_subscription_sessions",
    "path": "/chat/:customerId/subscription/sessions"
  }
} as const

export const APP_CHAT_CUSTOMER_SUBSCRIPTION_SESSIONS_REFOUND_ROUTES= {
  "root": {
    "name": "chat_customer_subscription_sessions_refound",
    "path": "/chat/:customerId/subscription/sessions/refound"
  }
} as const

export const APP_CHAT_CUSTOMER_SUBSCRIPTION_SESSIONS_REGISTER_ROUTES= {
  "root": {
    "name": "chat_customer_subscription_sessions_register",
    "path": "/chat/:customerId/subscription/sessions/register"
  }
} as const

export const APP_CHAT_CUSTOMER_SUBSCRIPTION_DISCHARGE_ROUTES= {
  "root": {
    "name": "chat_customer_subscription_discharge",
    "path": "/chat/:customerId/subscription/discharge"
  }
} as const

export const APP_CHAT_CUSTOMER_EVENTS_ROUTES= {
  "root": {
    "name": "chat_customer_events",
    "path": "/chat/:customerId/events"
  }
} as const

export const APP_CHAT_CUSTOMER_SCHEDULE_ROUTES= {
  "register": {
    "couple": {
      "root": {
        "name": "chat_customer_customer_appointments_register_couple",
        "path": "/chat/:customerId/schedule/register/couple"
      }
    },
    "root": {
      "name": "chat_customer_customer_appointments_register",
      "path": "/chat/:customerId/schedule/register"
    }
  },
  "view": {
    "root": {
      "name": "chat_customer_customer_appointments_view",
      "path": "/chat/:customerId/schedule/:appointmentId"
    }
  },
  "edit": {
    "couple": {
      "root": {
        "name": "chat_customer_customer_appointments_edit_couple",
        "path": "/chat/:customerId/schedule/edit/:appointmentId/couple"
      }
    },
    "root": {
      "name": "chat_customer_customer_appointments_edit",
      "path": "/chat/:customerId/schedule/edit/:appointmentId"
    }
  },
  "root": {
    "name": "chat_customer_customer_appointments",
    "path": "/chat/:customerId/schedule"
  }
} as const

export const APP_CHAT_CUSTOMER_SCHEDULE_REGISTER_ROUTES= {
  "couple": {
    "root": {
      "name": "chat_customer_customer_appointments_register_couple",
      "path": "/chat/:customerId/schedule/register/couple"
    }
  },
  "root": {
    "name": "chat_customer_customer_appointments_register",
    "path": "/chat/:customerId/schedule/register"
  }
} as const

export const APP_CHAT_CUSTOMER_SCHEDULE_REGISTER_COUPLE_ROUTES= {
  "root": {
    "name": "chat_customer_customer_appointments_register_couple",
    "path": "/chat/:customerId/schedule/register/couple"
  }
} as const

export const APP_CHAT_CUSTOMER_SCHEDULE_VIEW_ROUTES= {
  "root": {
    "name": "chat_customer_customer_appointments_view",
    "path": "/chat/:customerId/schedule/:appointmentId"
  }
} as const

export const APP_CHAT_CUSTOMER_SCHEDULE_EDIT_ROUTES= {
  "couple": {
    "root": {
      "name": "chat_customer_customer_appointments_edit_couple",
      "path": "/chat/:customerId/schedule/edit/:appointmentId/couple"
    }
  },
  "root": {
    "name": "chat_customer_customer_appointments_edit",
    "path": "/chat/:customerId/schedule/edit/:appointmentId"
  }
} as const

export const APP_CHAT_CUSTOMER_SCHEDULE_EDIT_COUPLE_ROUTES= {
  "root": {
    "name": "chat_customer_customer_appointments_edit_couple",
    "path": "/chat/:customerId/schedule/edit/:appointmentId/couple"
  }
} as const

export const APP_CHAT_CUSTOMER_PATIENTDETAIL_ROUTES= {
  "root": {
    "name": "chat_customer_patientDetail",
    "path": "/chat/:customerId/patient_detail"
  }
} as const

export const APP_CHAT_CUSTOMER_QUESTIONNAIRES_ROUTES= {
  "answers": {
    "root": {
      "name": "chat_customer_for_anwswers",
      "path": "/chat/:customerId/questionnaires/:quizId"
    }
  },
  "send": {
    "root": {
      "name": "chat_customer_for_send",
      "path": "/chat/:customerId/questionnaires/create"
    }
  },
  "root": {
    "name": "chat_customer_for",
    "path": "/chat/:customerId/questionnaires"
  }
} as const

export const APP_CHAT_CUSTOMER_QUESTIONNAIRES_ANSWERS_ROUTES= {
  "root": {
    "name": "chat_customer_for_anwswers",
    "path": "/chat/:customerId/questionnaires/:quizId"
  }
} as const

export const APP_CHAT_CUSTOMER_QUESTIONNAIRES_SEND_ROUTES= {
  "root": {
    "name": "chat_customer_for_send",
    "path": "/chat/:customerId/questionnaires/create"
  }
} as const

export const APP_CALENDARS_ROUTES= {
  "config": {
    "schedule": {
      "root": {
        "name": "calendars_config_schedule",
        "path": "/calendars/configuration/schedule"
      }
    },
    "advice_policy": {
      "root": {
        "name": "calendars_config_advicePolicy",
        "path": "/calendars/configuration/advice-policy"
      }
    },
    "root": {
      "name": "calendars_config",
      "path": "/calendars/configuration"
    }
  },
  "sync": {
    "root": {
      "name": "calendars_sync",
      "path": "/calendars/sync"
    }
  },
  "view": {
    "root": {
      "name": "calendars_view",
      "path": "/calendars/view"
    }
  },
  "root": {
    "name": "calendars",
    "path": "/calendars"
  }
} as const

export const APP_CALENDARS_CONFIG_ROUTES= {
  "schedule": {
    "root": {
      "name": "calendars_config_schedule",
      "path": "/calendars/configuration/schedule"
    }
  },
  "advice_policy": {
    "root": {
      "name": "calendars_config_advicePolicy",
      "path": "/calendars/configuration/advice-policy"
    }
  },
  "root": {
    "name": "calendars_config",
    "path": "/calendars/configuration"
  }
} as const

export const APP_CALENDARS_CONFIG_SCHEDULE_ROUTES= {
  "root": {
    "name": "calendars_config_schedule",
    "path": "/calendars/configuration/schedule"
  }
} as const

export const APP_CALENDARS_CONFIG_ADVICE_POLICY_ROUTES= {
  "root": {
    "name": "calendars_config_advicePolicy",
    "path": "/calendars/configuration/advice-policy"
  }
} as const

export const APP_CALENDARS_SYNC_ROUTES= {
  "root": {
    "name": "calendars_sync",
    "path": "/calendars/sync"
  }
} as const

export const APP_CALENDARS_VIEW_ROUTES= {
  "root": {
    "name": "calendars_view",
    "path": "/calendars/view"
  }
} as const

export const APP_ACTIVITY_ROUTES= {
  "root": {
    "name": "activityCenter",
    "path": "/activity-center"
  }
} as const

export const APP_SETTINGS_ROUTES= {
  "subscriptions": {
    "payment": {
      "add": {
        "root": {
          "name": "settings_subscriptions_payment_add",
          "path": "/settings/subscriptions/payment/add"
        }
      },
      "root": {
        "name": "settings_subscriptions_payment",
        "path": "/settings/subscriptions/payment"
      }
    },
    "plan": {
      "root": {
        "name": "settings_subscriptions_plan",
        "path": "/settings/subscriptions/plan"
      }
    },
    "privatePlan": {
      "root": {
        "name": "settings_subscriptions_privatePlan",
        "path": "/settings/subscriptions/:planId/private-patient-plan"
      }
    },
    "promoCode": {
      "root": {
        "name": "settings_subscriptions_promoCode",
        "path": "/settings/subscriptions/promo-code"
      }
    },
    "cancel": {
      "reason": {
        "root": {
          "name": "settings_subscriptions_cancel_reason",
          "path": "/settings/subscriptions/cancel/reason"
        }
      },
      "root": {
        "name": "settings_subscriptions_cancel",
        "path": "/settings/subscriptions/cancel"
      }
    },
    "sessions": {
      "root": {
        "name": "settings_subscriptions_sessions",
        "path": "/settings/subscriptions/sessions"
      }
    },
    "extra_sessions": {
      "root": {
        "name": "settings_subscriptions_extra_sessions",
        "path": "/settings/subscriptions/extra-sessions"
      }
    },
    "root": {
      "name": "settings_subscriptions",
      "path": "/settings/subscriptions"
    }
  },
  "loyaltyPlan": {
    "root": {
      "name": "settings_loyaltyPlan",
      "path": "/settings/objectives"
    }
  },
  "account": {
    "username": {
      "root": {
        "name": "settings_account_username",
        "path": "/settings/account/username"
      }
    },
    "password": {
      "root": {
        "name": "settings_account_password",
        "path": "/settings/account/password"
      }
    },
    "email": {
      "root": {
        "name": "settings_account_email",
        "path": "/settings/account/email"
      }
    },
    "description": {
      "root": {
        "name": "settings_account_description",
        "path": "/settings/account/description"
      }
    },
    "iban": {
      "root": {
        "name": "settings_account_iban",
        "path": "/settings/account/iban"
      }
    },
    "delete": {
      "reason": {
        "root": {
          "name": "settings_account_delete_reason",
          "path": "/settings/account/delete/reason"
        }
      },
      "root": {
        "name": "settings_account_delete",
        "path": "/settings/account/delete"
      }
    },
    "root": {
      "name": "settings_account",
      "path": "/settings/account"
    }
  },
  "configuration": {
    "schedule": {
      "root": {
        "name": "settings_myPreferences_schedule",
        "path": "/settings/configuration/schedule"
      }
    },
    "areas": {
      "root": {
        "name": "settings_myPreferences_areas",
        "path": "/settings/configuration/areas"
      }
    },
    "capaticy": {
      "root": {
        "name": "settings_myPreferences_patients",
        "path": "/settings/configuration/number-patients"
      }
    },
    "trial": {
      "root": {
        "name": "settings_myPreferences_trial",
        "path": "/settings/configuration/trial-period"
      }
    },
    "therapeuticApproaches": {
      "root": {
        "name": "settings_myPreferences_therapeutic-approaches",
        "path": "/settings/configuration/therapeutic-approaches"
      }
    },
    "educations": {
      "root": {
        "name": "settings_myPreferences_educations",
        "path": "/settings/configuration/educations"
      }
    },
    "additionalLanguages": {
      "root": {
        "name": "settings_myPreferences_additional-languages",
        "path": "/settings/configuration/additional-languages"
      }
    },
    "pricePerSession": {
      "root": {
        "name": "settings_myPreferences_price-per-session",
        "path": "/settings/configuration/price-per-session"
      }
    },
    "timeZone": {
      "root": {
        "name": "settings_myPreferences_timeZone",
        "path": "/settings/configuration/time_zone"
      }
    },
    "root": {
      "name": "settings_myPreferences",
      "path": "/settings/configuration"
    }
  },
  "help": {
    "view": {
      "root": {
        "name": "settings_help_helpView",
        "path": "/settings/help/:tag"
      }
    },
    "root": {
      "name": "settings_help",
      "path": "/settings/help"
    }
  },
  "invoices": {
    "detail": {
      "root": {
        "name": "settings_invoices_invoices_detail",
        "path": "/settings/invoices/invoices/detail/:year/:month"
      }
    },
    "root": {
      "name": "settings_invoices",
      "path": "/settings/invoices"
    }
  },
  "payments": {
    "detail": {
      "root": {
        "name": "settings_payments_payments_detail",
        "path": "/settings/payments/payments/detail/:year/:month"
      }
    },
    "root": {
      "name": "settings_payments",
      "path": "/settings/payments"
    }
  },
  "agreements": {
    "view": {
      "root": {
        "name": "settings_legalAgreements_view",
        "path": "/settings/legal-agreements/:uuid"
      }
    },
    "root": {
      "name": "settings_legalAgreements",
      "path": "/settings/legal-agreements"
    }
  },
  "notifications": {
    "root": {
      "name": "settings_notifications",
      "path": "/settings/notifications"
    }
  },
  "questionnaires": {
    "root": {
      "name": "settings_questionnaires",
      "path": "/settings/questionnaires"
    }
  },
  "patientReferral": {
    "root": {
      "name": "settings_referral",
      "path": "/settings/referral"
    }
  },
  "privacy": {
    "root": {
      "name": "settings_privacy",
      "path": "/settings/privacy"
    }
  },
  "timeZone": {
    "root": {
      "name": "settings_timeZone",
      "path": "/settings/time_zone"
    }
  },
  "root": {
    "name": "settings",
    "path": "/settings"
  }
} as const

export const APP_SETTINGS_SUBSCRIPTIONS_ROUTES= {
  "payment": {
    "add": {
      "root": {
        "name": "settings_subscriptions_payment_add",
        "path": "/settings/subscriptions/payment/add"
      }
    },
    "root": {
      "name": "settings_subscriptions_payment",
      "path": "/settings/subscriptions/payment"
    }
  },
  "plan": {
    "root": {
      "name": "settings_subscriptions_plan",
      "path": "/settings/subscriptions/plan"
    }
  },
  "privatePlan": {
    "root": {
      "name": "settings_subscriptions_privatePlan",
      "path": "/settings/subscriptions/:planId/private-patient-plan"
    }
  },
  "promoCode": {
    "root": {
      "name": "settings_subscriptions_promoCode",
      "path": "/settings/subscriptions/promo-code"
    }
  },
  "cancel": {
    "reason": {
      "root": {
        "name": "settings_subscriptions_cancel_reason",
        "path": "/settings/subscriptions/cancel/reason"
      }
    },
    "root": {
      "name": "settings_subscriptions_cancel",
      "path": "/settings/subscriptions/cancel"
    }
  },
  "sessions": {
    "root": {
      "name": "settings_subscriptions_sessions",
      "path": "/settings/subscriptions/sessions"
    }
  },
  "extra_sessions": {
    "root": {
      "name": "settings_subscriptions_extra_sessions",
      "path": "/settings/subscriptions/extra-sessions"
    }
  },
  "root": {
    "name": "settings_subscriptions",
    "path": "/settings/subscriptions"
  }
} as const

export const APP_SETTINGS_SUBSCRIPTIONS_PAYMENT_ROUTES= {
  "add": {
    "root": {
      "name": "settings_subscriptions_payment_add",
      "path": "/settings/subscriptions/payment/add"
    }
  },
  "root": {
    "name": "settings_subscriptions_payment",
    "path": "/settings/subscriptions/payment"
  }
} as const

export const APP_SETTINGS_SUBSCRIPTIONS_PAYMENT_ADD_ROUTES= {
  "root": {
    "name": "settings_subscriptions_payment_add",
    "path": "/settings/subscriptions/payment/add"
  }
} as const

export const APP_SETTINGS_SUBSCRIPTIONS_PLAN_ROUTES= {
  "root": {
    "name": "settings_subscriptions_plan",
    "path": "/settings/subscriptions/plan"
  }
} as const

export const APP_SETTINGS_SUBSCRIPTIONS_PRIVATEPLAN_ROUTES= {
  "root": {
    "name": "settings_subscriptions_privatePlan",
    "path": "/settings/subscriptions/:planId/private-patient-plan"
  }
} as const

export const APP_SETTINGS_SUBSCRIPTIONS_PROMOCODE_ROUTES= {
  "root": {
    "name": "settings_subscriptions_promoCode",
    "path": "/settings/subscriptions/promo-code"
  }
} as const

export const APP_SETTINGS_SUBSCRIPTIONS_CANCEL_ROUTES= {
  "reason": {
    "root": {
      "name": "settings_subscriptions_cancel_reason",
      "path": "/settings/subscriptions/cancel/reason"
    }
  },
  "root": {
    "name": "settings_subscriptions_cancel",
    "path": "/settings/subscriptions/cancel"
  }
} as const

export const APP_SETTINGS_SUBSCRIPTIONS_CANCEL_REASON_ROUTES= {
  "root": {
    "name": "settings_subscriptions_cancel_reason",
    "path": "/settings/subscriptions/cancel/reason"
  }
} as const

export const APP_SETTINGS_SUBSCRIPTIONS_SESSIONS_ROUTES= {
  "root": {
    "name": "settings_subscriptions_sessions",
    "path": "/settings/subscriptions/sessions"
  }
} as const

export const APP_SETTINGS_SUBSCRIPTIONS_EXTRA_SESSIONS_ROUTES= {
  "root": {
    "name": "settings_subscriptions_extra_sessions",
    "path": "/settings/subscriptions/extra-sessions"
  }
} as const

export const APP_SETTINGS_LOYALTYPLAN_ROUTES= {
  "root": {
    "name": "settings_loyaltyPlan",
    "path": "/settings/objectives"
  }
} as const

export const APP_SETTINGS_ACCOUNT_ROUTES= {
  "username": {
    "root": {
      "name": "settings_account_username",
      "path": "/settings/account/username"
    }
  },
  "password": {
    "root": {
      "name": "settings_account_password",
      "path": "/settings/account/password"
    }
  },
  "email": {
    "root": {
      "name": "settings_account_email",
      "path": "/settings/account/email"
    }
  },
  "description": {
    "root": {
      "name": "settings_account_description",
      "path": "/settings/account/description"
    }
  },
  "iban": {
    "root": {
      "name": "settings_account_iban",
      "path": "/settings/account/iban"
    }
  },
  "delete": {
    "reason": {
      "root": {
        "name": "settings_account_delete_reason",
        "path": "/settings/account/delete/reason"
      }
    },
    "root": {
      "name": "settings_account_delete",
      "path": "/settings/account/delete"
    }
  },
  "root": {
    "name": "settings_account",
    "path": "/settings/account"
  }
} as const

export const APP_SETTINGS_ACCOUNT_USERNAME_ROUTES= {
  "root": {
    "name": "settings_account_username",
    "path": "/settings/account/username"
  }
} as const

export const APP_SETTINGS_ACCOUNT_PASSWORD_ROUTES= {
  "root": {
    "name": "settings_account_password",
    "path": "/settings/account/password"
  }
} as const

export const APP_SETTINGS_ACCOUNT_EMAIL_ROUTES= {
  "root": {
    "name": "settings_account_email",
    "path": "/settings/account/email"
  }
} as const

export const APP_SETTINGS_ACCOUNT_DESCRIPTION_ROUTES= {
  "root": {
    "name": "settings_account_description",
    "path": "/settings/account/description"
  }
} as const

export const APP_SETTINGS_ACCOUNT_IBAN_ROUTES= {
  "root": {
    "name": "settings_account_iban",
    "path": "/settings/account/iban"
  }
} as const

export const APP_SETTINGS_ACCOUNT_DELETE_ROUTES= {
  "reason": {
    "root": {
      "name": "settings_account_delete_reason",
      "path": "/settings/account/delete/reason"
    }
  },
  "root": {
    "name": "settings_account_delete",
    "path": "/settings/account/delete"
  }
} as const

export const APP_SETTINGS_ACCOUNT_DELETE_REASON_ROUTES= {
  "root": {
    "name": "settings_account_delete_reason",
    "path": "/settings/account/delete/reason"
  }
} as const

export const APP_SETTINGS_CONFIGURATION_ROUTES= {
  "schedule": {
    "root": {
      "name": "settings_myPreferences_schedule",
      "path": "/settings/configuration/schedule"
    }
  },
  "areas": {
    "root": {
      "name": "settings_myPreferences_areas",
      "path": "/settings/configuration/areas"
    }
  },
  "capaticy": {
    "root": {
      "name": "settings_myPreferences_patients",
      "path": "/settings/configuration/number-patients"
    }
  },
  "trial": {
    "root": {
      "name": "settings_myPreferences_trial",
      "path": "/settings/configuration/trial-period"
    }
  },
  "therapeuticApproaches": {
    "root": {
      "name": "settings_myPreferences_therapeutic-approaches",
      "path": "/settings/configuration/therapeutic-approaches"
    }
  },
  "educations": {
    "root": {
      "name": "settings_myPreferences_educations",
      "path": "/settings/configuration/educations"
    }
  },
  "additionalLanguages": {
    "root": {
      "name": "settings_myPreferences_additional-languages",
      "path": "/settings/configuration/additional-languages"
    }
  },
  "pricePerSession": {
    "root": {
      "name": "settings_myPreferences_price-per-session",
      "path": "/settings/configuration/price-per-session"
    }
  },
  "timeZone": {
    "root": {
      "name": "settings_myPreferences_timeZone",
      "path": "/settings/configuration/time_zone"
    }
  },
  "root": {
    "name": "settings_myPreferences",
    "path": "/settings/configuration"
  }
} as const

export const APP_SETTINGS_CONFIGURATION_SCHEDULE_ROUTES= {
  "root": {
    "name": "settings_myPreferences_schedule",
    "path": "/settings/configuration/schedule"
  }
} as const

export const APP_SETTINGS_CONFIGURATION_AREAS_ROUTES= {
  "root": {
    "name": "settings_myPreferences_areas",
    "path": "/settings/configuration/areas"
  }
} as const

export const APP_SETTINGS_CONFIGURATION_CAPATICY_ROUTES= {
  "root": {
    "name": "settings_myPreferences_patients",
    "path": "/settings/configuration/number-patients"
  }
} as const

export const APP_SETTINGS_CONFIGURATION_TRIAL_ROUTES= {
  "root": {
    "name": "settings_myPreferences_trial",
    "path": "/settings/configuration/trial-period"
  }
} as const

export const APP_SETTINGS_CONFIGURATION_THERAPEUTICAPPROACHES_ROUTES= {
  "root": {
    "name": "settings_myPreferences_therapeutic-approaches",
    "path": "/settings/configuration/therapeutic-approaches"
  }
} as const

export const APP_SETTINGS_CONFIGURATION_EDUCATIONS_ROUTES= {
  "root": {
    "name": "settings_myPreferences_educations",
    "path": "/settings/configuration/educations"
  }
} as const

export const APP_SETTINGS_CONFIGURATION_ADDITIONALLANGUAGES_ROUTES= {
  "root": {
    "name": "settings_myPreferences_additional-languages",
    "path": "/settings/configuration/additional-languages"
  }
} as const

export const APP_SETTINGS_CONFIGURATION_PRICEPERSESSION_ROUTES= {
  "root": {
    "name": "settings_myPreferences_price-per-session",
    "path": "/settings/configuration/price-per-session"
  }
} as const

export const APP_SETTINGS_CONFIGURATION_TIMEZONE_ROUTES= {
  "root": {
    "name": "settings_myPreferences_timeZone",
    "path": "/settings/configuration/time_zone"
  }
} as const

export const APP_SETTINGS_HELP_ROUTES= {
  "view": {
    "root": {
      "name": "settings_help_helpView",
      "path": "/settings/help/:tag"
    }
  },
  "root": {
    "name": "settings_help",
    "path": "/settings/help"
  }
} as const

export const APP_SETTINGS_HELP_VIEW_ROUTES= {
  "root": {
    "name": "settings_help_helpView",
    "path": "/settings/help/:tag"
  }
} as const

export const APP_SETTINGS_INVOICES_ROUTES= {
  "detail": {
    "root": {
      "name": "settings_invoices_invoices_detail",
      "path": "/settings/invoices/invoices/detail/:year/:month"
    }
  },
  "root": {
    "name": "settings_invoices",
    "path": "/settings/invoices"
  }
} as const

export const APP_SETTINGS_INVOICES_DETAIL_ROUTES= {
  "root": {
    "name": "settings_invoices_invoices_detail",
    "path": "/settings/invoices/invoices/detail/:year/:month"
  }
} as const

export const APP_SETTINGS_PAYMENTS_ROUTES= {
  "detail": {
    "root": {
      "name": "settings_payments_payments_detail",
      "path": "/settings/payments/payments/detail/:year/:month"
    }
  },
  "root": {
    "name": "settings_payments",
    "path": "/settings/payments"
  }
} as const

export const APP_SETTINGS_PAYMENTS_DETAIL_ROUTES= {
  "root": {
    "name": "settings_payments_payments_detail",
    "path": "/settings/payments/payments/detail/:year/:month"
  }
} as const

export const APP_SETTINGS_AGREEMENTS_ROUTES= {
  "view": {
    "root": {
      "name": "settings_legalAgreements_view",
      "path": "/settings/legal-agreements/:uuid"
    }
  },
  "root": {
    "name": "settings_legalAgreements",
    "path": "/settings/legal-agreements"
  }
} as const

export const APP_SETTINGS_AGREEMENTS_VIEW_ROUTES= {
  "root": {
    "name": "settings_legalAgreements_view",
    "path": "/settings/legal-agreements/:uuid"
  }
} as const

export const APP_SETTINGS_NOTIFICATIONS_ROUTES= {
  "root": {
    "name": "settings_notifications",
    "path": "/settings/notifications"
  }
} as const

export const APP_SETTINGS_QUESTIONNAIRES_ROUTES= {
  "root": {
    "name": "settings_questionnaires",
    "path": "/settings/questionnaires"
  }
} as const

export const APP_SETTINGS_PATIENTREFERRAL_ROUTES= {
  "root": {
    "name": "settings_referral",
    "path": "/settings/referral"
  }
} as const

export const APP_SETTINGS_PRIVACY_ROUTES= {
  "root": {
    "name": "settings_privacy",
    "path": "/settings/privacy"
  }
} as const

export const APP_SETTINGS_TIMEZONE_ROUTES= {
  "root": {
    "name": "settings_timeZone",
    "path": "/settings/time_zone"
  }
} as const

export const APP_ERROR_ROUTES= {
  "404": {
    "root": {
      "name": "error_404",
      "path": "/errors/404"
    }
  },
  "offline": {
    "root": {
      "name": "error_offline",
      "path": "/errors/offline"
    }
  },
  "root": {
    "name": "error",
    "path": "/errors"
  }
} as const

export const APP_ERROR_404_ROUTES= {
  "root": {
    "name": "error_404",
    "path": "/errors/404"
  }
} as const

export const APP_ERROR_OFFLINE_ROUTES= {
  "root": {
    "name": "error_offline",
    "path": "/errors/offline"
  }
} as const

export const APP_LOGIN_ROUTES= {
  "root": {
    "name": "login",
    "path": "/login"
  }
} as const

export const APP_RECOVERPASSWORD_ROUTES= {
  "root": {
    "name": "recoverPassword",
    "path": "/recover-password"
  }
} as const

export const APP_RESETPASSWORD_ROUTES= {
  "root": {
    "name": "resetPassword",
    "path": "/reset-password"
  }
} as const

export const APP_ONBOARDING_ROUTES= {
  "root": {
    "name": "guest",
    "path": "/guest"
  }
} as const

export const APP_CODE_ROUTES= {
  "root": {
    "name": "loginCode",
    "path": "/login-code"
  }
} as const

export const APP_REFRESHSTRIPE_ROUTES= {
  "root": {
    "name": "refreshStripe",
    "path": "/refresh-stripe-account"
  }
} as const

export const APP_SSO_ROUTES= {
  "root": {
    "name": "sso",
    "path": "/auth"
  }
} as const

export const APP_AGENT_ROUTES= {
  "root": {
    "name": "agent",
    "path": "/agent"
  }
} as const